export function customOfflineMessage(url) {
  url = String(url);

  const defaultMessage =
    "NÃO FOI POSSÍVEL ESTABELECER A CONEXÃO. VOLTE A DASHBOARD PARA USAR O SISTEMA EM MODO OFFLINE.";
  const noConnection = "SEM ACESSO AO SERVIDOR. VERIFIQUE SUA INTERNET.";

  return (
    {
      /**
       * códigos de erro
       */

      "404": "URL não encontrada",
      // "401": "Sessão expirada. Faça login para continuar",

      /**
       * rotas
       */

      // login
      "/rest-home/user/verify/email": noConnection,
      "/rest-home/user/auth": noConnection,
    }[url] || defaultMessage
  );
}
